import { render, staticRenderFns } from "./GarageDoorImpacts.vue?vue&type=template&id=38c6600c&scoped=true"
import script from "./GarageDoorImpacts.vue?vue&type=script&lang=ts"
export * from "./GarageDoorImpacts.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c6600c",
  null
  
)

export default component.exports